import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";

const TermsConditions = () => {
  return (
    <>
      <Navbar />

      {/* Page Header */}
      <div style={styles.header}>
        <div style={styles.container}>
          <h1 style={styles.title}>Term Conditions Page</h1>
          <div style={styles.breadcrumb}>
            Home / <span style={styles.active}>“Terms & conditions”</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={styles.contentWrapper}>
        <div style={styles.container}>
          <p><strong>Effective Date:</strong> January 28, 2026</p>

          <p><strong>Welcome to Z1 Technology and Trade Pvt. Ltd !</strong></p>

          <p>
            These Terms and Conditions outline the rules and regulations for using
            our website and mobile app. By accessing or using Z1 Technology and Trade, you
            agree to comply with and be bound by these terms. If you do not agree
            with these terms, please refrain from using our services.
          </p>

          <Section
            title="1. Acceptance of Terms"
            text="By accessing or using Z1 Technology and Trade, you agree to comply with these Terms and Conditions, as well as any applicable laws and regulations. These terms may be updated from time to time, and your continued use of the platform constitutes your acceptance of any changes."
          />

          <Section
            title="2. User Accounts"
            text="To use certain features of Z1 Technology and Trade, you may be required to create an account. You agree to:"
            list={[
              "Provide accurate, current, and complete information during registration.",
              "Keep your account information confidential and secure.",
            ]}
          />

          <Section
            title="3. Prohibited Activities"
            text="When using Z1 Technology and Trade, you agree to refrain from:"
            
          />
          <p>a. Engaging in any illegal, fraudulent, or harmful activity.</p>
          <p>b. Uploading, posting, or distributing any content that is unlawful, harmful, or violates the rights of others.</p>
          <p>c. Interfering with the operation of the platform or accessing data not intended for you.</p>
          <p>d. Using the platform for any commercial purposes without prior authorization.</p>

          <Section
            title="4. Buying and Selling on Z1 Technology and Trade"
            text="For Buyers: When making a purchase, you agree to review the product details and terms of sale. Z1 Technology and Trade is not responsible for issues arising from incorrect product descriptions or failure to read the terms. Payments must be made through authorized methods."
          />

          <Section
            text="For Sellers: You agree to provide accurate descriptions of products and honor all sales and warranties as per Nepalese law. Sellers are responsible for delivering products in a timely manner. Failure to comply with selling standards may result in suspension or termination of your account."
          />

          <Section
            title="5. Order Cancellations and Refunds"
            text="Refunds are issued based on the refund policies of the respective sellers. Please review individual product listings for refund conditions. Z1 Technology and Trade facilitates refunds but does not guarantee them."
          />

          <Section
            title="6. Delivery and Shipping"
            text="We offer instant delivery services in Butwal, Bhairahwa, and Kapilvastu, where products will be delivered within 30 minutes. For other locations across Nepal, delivery times will vary."
          />

          <Section
            title="7. Intellectual Property"
            text="All content on SajiloBazar, including logos, images, text, and software, is the intellectual property of Z1 Technology and Trade or our licensors. You may not use, reproduce, or distribute any content without prior written permission from us."
          />

          <Section
            title="8. Limitation of Liability"
            text="Z1 Technology and Trade is a marketplace connecting buyers and sellers, and we do not assume responsibility for any disputes, damages, or losses arising from transactions between users. We are not liable for any errors, omissions, interruptions, or delays in the service."
          />

          <Section
            title="9. Termination"
            text="We reserve the right to suspend or terminate your account and access to Z1 Technology and Trade if you violate these Terms and Conditions or engage in any conduct that we deem harmful to our platform or other users."
          />

          <Section
            title="10. Changes to Terms"
            text="Z1 Technology and Trade reserves the right to update or modify these Terms and Conditions at any time. We will notify users of significant changes by posting a notice on the platform or by other means as required."
          />

          <Section
            title="11. Governing Law"
            text="These Terms and Conditions are governed by the laws of Nepal. Any disputes arising out of the use of Z1 Technology and Trade will be resolved in accordance with Nepalese law."
          />

          <Section title="13. Contact Us">
            <p>
              If you have any questions or concerns regarding these Terms and
              Conditions, please contact us at:
            </p>

            <p style={{ marginTop: "16px" }}>
              <strong>Z.One Technology & Trade Pvt. Ltd.</strong><br />
              Siddharthanagar-12, Bhairahawa, Lumbini, Nepal<br />
              Email: z1techbhw@gmail.com<br />
              Phone: 071590132, 9857050123
            </p>
          </Section>
        </div>
      </div>

      <Footer />
    </>
  );
};

const Section = ({ title, text, list, children }) => (
  <div style={styles.section}>
    <h3 style={styles.sectionTitle}>{title}</h3>
    {text && <p>{text}</p>}
    {list && (
      <ul>
        {list.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    )}
    {children}
  </div>
);

const styles = {
  header: {
    padding: "40px 0",
    background: "#ffffff",
    borderBottom: "1px solid #e5e7eb",
  },
  container: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "0 16px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "6px",
  },
  breadcrumb: {
    fontSize: "14px",
    color: "#6b7280",
  },
  active: {
    color: "#2563eb",
  },
  contentWrapper: {
    padding: "40px 0",
    background: "#ffffff",
  },
  section: {
    marginTop: "28px",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "700",
    marginBottom: "8px",
  },
};

export default TermsConditions;
